/****************** ** Método para extraer datos de sesión ***************************************************+*/
const getIdentity = () => {
    return {
        identity: localStorage.getItem('iden') !== null ? JSON.parse(localStorage.getItem('iden')) : null,
        token: localStorage.getItem('tok') !== null ? (localStorage.getItem('tok')) : null,
    }
}

/****************** * Verificar estado de session ***************************************************+*/
const isLogged = (iden, tok) => {
    return iden !== null && tok !== null
}


module.exports = {
    getIdentity,
    isLogged
}